import Spacing from 'components/Common/Spacing'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import LFSEOfferTypeTiles from './LFSEOfferTypeTiles'
import { mediaQueryUp } from 'components/utils/breakpoint'
import PaletteProvider from 'contexts/PaletteProvider'

const Container = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.seven};
  padding-left: ${rem(20)};
  padding-right: ${rem(20)};
  height: 100%;

  ${mediaQueryUp.xxs} {
    padding-left: ${rem(40)};
    padding-right: ${rem(40)};
  }
`

export function HeroOfferCarouselLookingForSomethingElse() {
  return (
    <PaletteProvider type="inverse" >
      <Container direction="vertical" horizontalAlign="center" verticalAlign="center">
        <Heading align="center" variant="heading5">Looking for something else?</Heading>
        <Spacing mt={8} mb={24}>
          <BodyText colour="neutral-two" align="center" variant="medium">Browse all destinations or products for more amazing offers</BodyText>
        </Spacing>
        <PaletteProvider type="default" >
          <Group direction="vertical" gap={8}>
            <LFSEOfferTypeTiles />
          </Group>
        </PaletteProvider>
      </Container>
    </PaletteProvider>
  )
}
